export default __webpack_public_path__ + "static/media/gallery_01.87e9dc2e.jpg";